import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Currency, PaymentDto, PaymentStatus} from "@/store/player/types";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import { Tr } from "@/i18n/i18n";

export class PaymentAdminPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, p: PaymentDto, playerId: number) {
        super(scene);

        this.scene = scene;
        this.height = 120;

        const timeText = TextUtils.addTextAdvanced(scene, p.initiatedAt + Tr('level') + String(p.playerLevel) +
            ' ' + Tr('emeralds.small') + String(p.playerMithril)+ ')', -284, 22,
            '#ffdb60', 13, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        const emeraldsForText = p.receiverId === playerId ? Tr('emeralds.for') : Tr('gift.emeralds.for');

        const descText = TextUtils.addTextAdvanced(scene, Tr('purchase') + String(p.rubTotal) +
            emeraldsForText + String(p.price) + ' ' + this.getCurrencyString(p.currency) + '\n-- ' + this.getStatusString(p.status) + 
            ' --\n' + Tr('payment.id') + String(p.transactionId) +
            '\n' + Tr('receiver.id') + String(p.receiverId), -284, 72,
            '#e2e2e2', 13, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        const sep = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0);

        this.add([timeText, descText, sep]);
    }

    getCurrencyString(c: Currency) : string {
        switch (c){
            case Currency.DEFAULT:
                return Tr('rub.small');
            case Currency.USD:
                return "$";
            case Currency.EUR:
                return "€";
        }
    }

    getStatusString(s: PaymentStatus) : string {
        switch (s){
            case PaymentStatus.STARTED:
                return Tr('payment.srated');
            case PaymentStatus.GEMS_GRANTED:
                return Tr('emeralds.accrued.but.not.received');
            case PaymentStatus.GEMS_TAKEN:
                return Tr('gems.received').toUpperCase();
            case PaymentStatus.REFUNDED:
                return Tr('return');

        }
    }


}
